module.exports = __webpack_public_path__ + "static/article-image-bcd9f94b2730bc042b27058568a2e61a.png";